import styled from "styled-components";
const bgFlorence = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/background-florence.svg`;

export const UserGeneralNote = styled.div`
  .container {
    background-color: #FFFFFF;
    box-shadow: 0px 3px 10.4px 1px #9395CC3D;
    border-radius: 20px;
    padding: 15px;
    width: 317px;
    display: flex;
    flex-direction: column;
  }
  .no-note {
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__title {
      font-family: Nunito Sans Bold;
      font-size: 17px;
      color: #1F1F52;
    }
    &__icon {
      font-size: 15px;
      color: #707582;
    }
    &__description {
      margin: 15px 0;
      font-family: Nunito Sans;
      font-size: 14px;
      color: #3E3E5B;
    }
    &__button {
      width: 100%;
    }
  }
  .note {
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__doctor {
      font-family: Nunito Sans;
      font-size: 15px;
      text-align: center;
      color: #1F1F52;
    }
    &__date {
      font-family: Nunito Sans;
      font-size: 13px;
      color: #707582;
    }
    &__option {
      cursor: pointer;
      background: #F0F0FF;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      &-icon {
        font-size: 12px;
        color: #2A28D6;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
      }
    }
    &__text {
      height: 139px;
      overflow-y: auto;
      margin-top: 15px;
      color: #3E3E5B;
      font-size: 14px;
    }
  }
  .note-edition {
    &__header {
      display: flex;
      align-items: center;
    }
    &__title {
      font-family: Nunito Sans;
      font-size: 17px;
      color: #1F1F52;
    }
    &__icon {
      font-size: 7px;
      color: #1F1F52;
      margin-left: 10px;
    } 
    &__text {
      margin-top: 10px;   
      height: 144px;  
    }
    &__footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 10px;

    }
    &__button {
      width: 36px;
      margin-left: 10px;
    }
  }
`;


export const CardOptions = styled.div`
  width: 121px;
  padding: 10px;
  border-radius: 10px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 12px 0px #23229D33;
  .card-option {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    &__icon {
      margin-right: 10px;
      color: #3E3DA3;
      font-size: 1opx;
    }
    &__text {
      font-family: Nunito Sans;
      font-size: 17px;
      color: #3E3DA3;
    }
  }
`